export default "__VITE_ASSET__12634623__"